// LLM generated - Model Claude 4 Sonnet
import { IconSpeakerphone } from '@tabler/icons-react';
import useTranslation from 'next-translate/useTranslation';

import { EmptyState } from '../../../EmptyState';
import type { PostEmptyStateProps } from './types';

function PostEmptyState({ commissionerHandle = 'the commissioner' }: PostEmptyStateProps) {
  const { t } = useTranslation('chat');

  return (
    <EmptyState
      icon={<IconSpeakerphone size={40} />}
      title={t('emptyStates.posts.title')}
      description={t('emptyStates.posts.description', { commissionerHandle })}
      size="md"
      c="gray2.3"
    />
  );
}

function PostEmptyStateCommish({ commissionerHandle = 'the commissioner' }: PostEmptyStateProps) {
  const { t } = useTranslation('chat');

  return (
    <EmptyState
      icon={<IconSpeakerphone size={40} />}
      title={t('emptyStates.posts.title')}
      description={t('emptyStates.posts.descriptionCommish', { commissionerHandle })}
      size="md"
      c="gray2.3"
    />
  );
}

export { PostEmptyState, PostEmptyStateCommish };
